import { parseISO, format, isValid } from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/index.js";
import React, { useEffect, useState } from "react";
import { FiCheck, FiChevronRight } from "react-icons/fi";

import * as Styles from "./styles";

import correiosLogo from "../../assets/correios-logo.png";
import pixLogoCyan from "../../assets/pix-logo-cyan.svg";
import pixLogoFull from "../../assets/pix-logo-full.png";
import pixLogoWhite from "../../assets/pix-logo-white.svg";

import { PixPaymentInstructionsDrawer } from "..";
import { useTimer } from "../../../CheckoutDefault/hooks/useTimer";
import { parseCurrency, parseMsisdn } from "../../utils";

const paymentStatuses = {
  PENDING: {
    name: "Pendente",
    text: "Recarga aguardando pagamento",
    color: "red",
  },
  PAID: {
    name: "Pago",
    text: "Recarga paga com sucesso",
    color: "#00b894",
  },
  EXPIRED: {
    name: "Expirado",
    text: "Recarga expirada",
    color: "red",
  },
};

export function PixReceipt({ msisdn, isLoading, paymentData, plan }) {
  const [isCodeCopied, setIsCodeCopied] = useState(false);

  const [isExpired, setIsExpired] = useState(paymentData?.status === "EXPIRED");
  const paymentStatus =
    paymentStatuses[isExpired ? "EXPIRED" : paymentData?.status || "PENDING"];
  const tableItems = [
    { name: "Plano", value: `${plan.value.slice(0, 2)}` },
    { name: "Número", value: parseMsisdn(msisdn) },
    { name: "Valor", value: parseCurrency(plan.value) },
    {
      name: "Pagamento",
      value: paymentStatus.name,
      color: paymentStatus.color,
    },
  ];

  function handleCopyCode() {
    navigator.clipboard.writeText(paymentData?.pix_code);
    setIsCodeCopied(true);

    setTimeout(() => {
      setIsCodeCopied(false);
    }, 5000);
  }

  const dateParsed =
    paymentData?.expiration_date &&
    paymentData?.expiration_date !== "" &&
    parseISO(paymentData?.expiration_date);

  const formattedDate = format(
    isValid(dateParsed) ? dateParsed : new Date(),
    "'Dia' dd 'de' MMMM', às ' HH:mm",
    { locale: ptBR }
  );

  return (
    <Styles.Container>
      <Styles.Header>
        <img src={correiosLogo} alt="Correios Celular" />
        <img src={pixLogoFull} alt="PIX" />
      </Styles.Header>
      <Styles.Main>
        <h1>
          {isLoading ? "Gerando pagamento via PIX..." : paymentStatus.text}
        </h1>
        {!isLoading && (
          <>
            {isExpired ? (
              <>
                <p>
                  O prazo para pagamento da recarga expirou. Por favor, gere um
                  novo código PIX.
                </p>

                <Styles.Button
                  variant="primary"
                  onClick={() => window.location.reload()}
                >
                  <img src={pixLogoWhite} alt="" />
                  Gerar novo código PIX
                </Styles.Button>
              </>
            ) : (
              <>
                <p>
                  Copie o código abaixo para pagar via PIX em qualquer
                  aplicativo habilitado:
                </p>
                <Styles.QrCodeImage
                  src={`data: image / png; base64, ${paymentData?.qr_code_base64}`}
                  alt="QR Code"
                />
                {!!paymentData?.qr_code_base64 && (
                  <Styles.Button
                    variant="primary"
                    onClick={handleCopyCode}
                    disabled={isCodeCopied || paymentData?.status === "PAID"}
                  >
                    {isCodeCopied ? (
                      <FiCheck size={25} />
                    ) : (
                      <img src={pixLogoWhite} alt="" />
                    )}
                    Copiar código Pix
                  </Styles.Button>
                )}

                {!isExpired && <p id="timer">Pague até: {formattedDate}</p>}
              </>
            )}
            <Styles.ReceiptTable>
              {tableItems.map((item) => (
                <Styles.ReceiptItem key={item.name} color={item.color}>
                  <p>{item.name}</p>
                  <p>{item.value}</p>
                </Styles.ReceiptItem>
              ))}
            </Styles.ReceiptTable>
            <PixPaymentInstructionsDrawer>
              <Styles.Button>
                <img src={pixLogoCyan} alt="" />
                Instruções de como usar o Pix
                <FiChevronRight />
              </Styles.Button>
            </PixPaymentInstructionsDrawer>
          </>
        )}
      </Styles.Main>
    </Styles.Container>
  );
}
